import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../../../PanelPage";
import {ChooseAddressComponent} from "./components/ChooseAddressComponent";
import {Controller} from "../../../flows/Controller.js";
import {UserAddressStore} from "../../../../../client/state/UserAddressStore";
import {MerchantButton} from "../../../../common/MerchantButton";
import {Messages} from "../../../../Messages";
import {AddAddressComponent} from "./components/AddAddressComponent";
import {EditAddressComponent} from "./components/EditAddressComponent";
import {iFrameUserDataService} from "../../../../services/IFrameUserDataService";
import {Router} from "../../../../../stem-core/src/ui/Router";


export const ADDRESS_SECTION_STATE = {
    chooseAddress: "chooseAddress",
    addAddress: "addAddress",
    continueWithAddedAddress: "continueWithAddedAddress",
    editAddress: "editAddress",
};

const ADDRESS_SECTION_MAP = {
    [ADDRESS_SECTION_STATE.chooseAddress]: ChooseAddressComponent,
    [ADDRESS_SECTION_STATE.addAddress]: AddAddressComponent,
    [ADDRESS_SECTION_STATE.continueWithAddedAddress]: AddAddressComponent,
    [ADDRESS_SECTION_STATE.editAddress]: EditAddressComponent, // TODO @cleanup WAT? WHY?
};

export class AddressPanel extends BasePanelPage {
    getDefaultOptions(options) {
        return {
            ...super.getDefaultOptions(options),
            title: () => Controller.address.addressSectionState === ADDRESS_SECTION_STATE.chooseAddress ?
                Messages.chooseAddress : Messages.addNewAddress,
        };
    }

    getAddressSectionState() {
        if (!Controller.address.selectedAddress && !iFrameUserDataService.getExtraUserAddressCount()) {
            return ADDRESS_SECTION_STATE.continueWithAddedAddress;
        }
        return Controller.address.addressSectionState;
    }

    isButtonDisabled() {
        return !(this.addressComponent?.isValid());
    }

    render() {
        if (!Controller.address.selectedAddress && Controller.address.addressSectionState !== ADDRESS_SECTION_STATE.addAddress) {
            const selectedAddress = UserAddressStore.all()[0];
            Controller.address.update({
                selectedAddress,
                addressSectionState: (selectedAddress || iFrameUserDataService.getExtraUserAddressCount()) ?
                    ADDRESS_SECTION_STATE.chooseAddress : ADDRESS_SECTION_STATE.continueWithAddedAddress,
            });
        }

        const {styleSheet} = this;
        const AddressComponent = ADDRESS_SECTION_MAP[this.getAddressSectionState()];
        const onAddNewAddress = () => {
            Controller.address.addressSectionState = ADDRESS_SECTION_STATE.addAddress;
            Router.updateURL(); // TODO @cleanup why not just redraw?
        };

        const buttonLabelMap = {
            [ADDRESS_SECTION_STATE.chooseAddress]: Controller.address.continueLabel || Messages.continue,
            [ADDRESS_SECTION_STATE.editAddress]: Messages.editAddress,
            [ADDRESS_SECTION_STATE.continueWithAddedAddress]: Controller.address.continueLabel || Messages.addNewAddress,
            [ADDRESS_SECTION_STATE.addAddress]: Messages.addNewAddress,
        }

        return [
            <AddressComponent
                ref="addressComponent"
                onChange={() => this.redraw()}
                onAddNewAddress={onAddNewAddress}
            />,
            <MerchantButton
                disabled={this.isButtonDisabled()}
                onClick={() => this.handlePrimaryButtonClick()}
                testId="addressButton"
                ref="addressButton"
                className={styleSheet.actionButton}
            >
                {buttonLabelMap[this.getAddressSectionState()]}
            </MerchantButton>,
            <div className={styleSheet.backButton}
                 onClick={() => {
                    if (Controller.address.addressSectionState === ADDRESS_SECTION_STATE.addAddress) {
                        Controller.address.addressSectionState = ADDRESS_SECTION_STATE.chooseAddress;
                        Router.updateURL();
                    } else {
                        Router.back();
                    }
                }}>
                {Messages.back}
            </div>
        ]
    }

    async handlePrimaryButtonClick() {
        const selectedAddress = await this.addressComponent.getAddress();
        if (!selectedAddress) {
            // An error must have happened in address validation
            return;
        }
        Controller.address.update({selectedAddress});
        if (Controller.address.addressSectionState === ADDRESS_SECTION_STATE.addAddress) {
            Controller.address.addressSectionState = ADDRESS_SECTION_STATE.chooseAddress;
            Router.updateURL();
        } else {
            await Controller.address.onSelectSuccess();
        }
    }

    onMount() {
        super.onMount();

        this.addressButton.updateOptions({disabled: this.isButtonDisabled()}); // TODO @cleanup hack to handle Denis's shit architecture
        this.attachChangeListener(UserAddressStore, () => this.redraw());
    }
}
